import { Colours, Sizes, Fonts } from '../../../../../style_helpers'

export default {
  base: {
    fontSize: Sizes(0),
    fontFamily: Fonts('gibson'),
    padding: `${Sizes(-7)} ${Sizes(0)}`,
    backgroundColor: Colours('white', '300')
  },

  hover: {
    backgroundColor: Colours('grey', '100')
  },

  active: {
    color: Colours('uiBlue', '300')
  }
}
